import { Moon, Sun, SunMoon } from 'lucide-react';
import { useThemeMode } from '@/contexts/ThemeModeContext';

const MODE_OPTIONS = [
    { value: 'light', label: 'Light', menuLabel: '☀ Light' },
    { value: 'dark', label: 'Dark', menuLabel: '☾ Dark' },
    { value: 'system', label: 'System', menuLabel: '◐ System' },
];

export default function ThemeModeToggle() {
    const { mode, setMode } = useThemeMode();

    const ActiveIcon = mode === 'light'
        ? Sun
        : mode === 'dark'
            ? Moon
            : SunMoon;
    const activeLabel = MODE_OPTIONS.find((option) => option.value === mode)?.label || 'Theme mode';

    return (
        <label
            className="relative inline-flex size-11 cursor-pointer items-center justify-center overflow-hidden rounded-full transition-all hover:bg-white/10"
            title={activeLabel}
        >
            <ActiveIcon size={22} className="pointer-events-none text-white drop-shadow-[0_1px_2px_rgba(0,0,0,0.55)]" />
            <select
                value={mode}
                onChange={(event) => setMode(event.target.value)}
                className="absolute inset-0 cursor-pointer opacity-0"
                aria-label="Theme mode"
            >
                {MODE_OPTIONS.map((option) => (
                    <option key={option.value} value={option.value}>
                        {option.menuLabel}
                    </option>
                ))}
            </select>
            <span className="sr-only">{activeLabel}</span>
        </label>
    );
}
